import { memo } from 'react';

import * as ui from '@april9au/stack9-ui';

export const ActionBarComponent = memo(
  ({ defaultActions }: ui.ActionBarComponentProps) => (
    <>
      {/*
      Example how to  custom action for a specific route.
      <Routes>
        <Route path="/example-route" element={<Component />} />
      </Routes>
      */}
      {defaultActions}
    </>
  ),
);
